<template>
  <section class="vue-winwheel">
    <div class="mobile-container">
      <h1>Spin to win amazing prizes</h1>
      <div class="wheel-wrapper">
        <div class="canvas-wrapper">
          <canvas id="canvas" width="310" height="310">
            <p style="{color: white}" align="center">Sorry, your browser doesn't support canvas. Please try Google Chrome.</p>
          </canvas>
        </div>
        <div class="button-wrapper">
          <a class="btn btn-play" href="#" @click.prevent="startSpin()" v-if="!loadingPrize && !wheelSpinning">SPIN!</a>
        </div>
      </div>
    </div>
    <transition v-if="modalPrize" name="modal-fade">
      <div class="modal-backdrop">
        <div class="modal"
             role="dialog"
             aria-labelledby="modalTitle"
             aria-describedby="modalDescription"
        >
          <section
              class="modal-body"
              id="modalDescription"
          >
            <slot name="body">
              <img v-if="winner" style="width: 100%;" :src="image_url">
              <i v-if="!winner"> 😔 Ooops! Try your luck on the next one 😔</i>
              <h5>You landed on: {{prizeName}}</h5>
            </slot>
          </section>
        </div>
      </div>
    </transition>
    <!--			<div class="custom-modal modal-mask" id="modalSpinwheel" v-if="modalPrize">-->
    <!--				<div slot="body">-->
    <!--					<a href="" @click.prevent="hidePrize()" class="modal-dismiss">-->
    <!--						<i class="icon_close"></i>-->
    <!--					</a>-->
    <!--					<h2>-->
    <!--						Yay you got the prize!!-->
    <!--					</h2>-->
    <!--					<h1> {{prizeName}}</h1>-->
    <!--				</div>-->
    <!--			</div>-->
  </section>
</template>


<script>
import * as Winwheel from './Winwheel'
import axios from "axios";

export default {
  name: 'VueWinWheel',
  props:{
    segments:{
      default(){
        return [
          {
            textFillStyle: '#fff',
            fillStyle: '#93278f',
            text:'20% Discount'
          },
          {
            textFillStyle: '#93278f',
            fillStyle: '#fff',
            text:'No Luck'
          },
          {
            textFillStyle: '#fff',
            fillStyle: '#93278f',
            text:'Unlucky'
          },
          {
            textFillStyle: '#93278f',
            fillStyle: '#fff',
            text:'Merchandise'
          },
          {
            textFillStyle: '#fff',
            fillStyle: '#93278f',
            text:'Woiii'
          },
          {
            textFillStyle: '#93278f',
            fillStyle: '#fff',
            text:'Tough Luck'
          },
          {
            textFillStyle: '#fff',
            fillStyle: '#93278f',
            text:'No Luck'
          },
          {
            textFillStyle: '#93278f',
            fillStyle: '#fff',
            text:'No Luck'
          },
          {
            textFillStyle: '#fff',
            fillStyle: '#93278f',
            text:'No Luck'
          },
          {
            textFillStyle: '#93278f',
            fillStyle: '#fff',
            text:'No Luck'
          }
        ]
      }
    }
  },
  data () {
    return {
      winner:false,
      loadingPrize: false,
      theWheel: null,
      modalPrize: false,
      wheelPower: 1,
      image_url:'',
      wheelSpinning: false,
      prize:'unlucky',
      prizeName: 'Free Vouchers!',
      WinWheelOptions: {
        textFontSize: 14,
        outterRadius: 410,
        innerRadius: 25,
        lineWidth: 8,
        animation: {
          type: 'spinOngoing',
          duration: 0.5
        }
      }
    }
  },
  methods: {
    getPrizes()
    {
      let context = this;
      const api = "https://create.tuni.ke/api/reward/spin/mpesa";
      const qs = require('qs')
      axios({
        method: 'post',
        url: api,
        data: qs.stringify({
          'trivia_id': this.$store.state.matchSlug,
          'player_id': this.$store.state.scores.playerOne.id,
          'isp':this.$store.state.isp
        }),
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }).then(response => {
        context.prize = response.data.data;
        console.log(response.data)
      })
    },
    showPrize () {
      let vm = this;
      this.modalPrize = true
      console.log('here1');
      setTimeout(() => {
        vm.advance();
      }, 4500)
    },
    hidePrize () {
      //this.modalPrize = false
    },
    startSpin () {
      let context =this;
      this.hidePrize ();
      if (this.wheelSpinning === false) {
        this.theWheel.startAnimation()
        this.wheelSpinning = true
        this.theWheel = new Winwheel.Winwheel({
          ...this.WinWheelOptions,
          numSegments: this.segments.length,
          segments: this.segments,
          animation: {
            type: 'spinToStop',
            duration: 5,
            spins: 5,
            callbackFinished: this.onFinishSpin
          }
        })

        // example input prize number get from Backend
        // Important thing is to set the stopAngle of the animation before stating the spin.
        let pp ;
        if (context.prize == 'pesa_voucher')
        {
          pp = 1
          this.winner = true;
        }
        if (context.prize == 'pesa_gift_voucher')
        {
          pp = 2
          this.winner = true;
        }
        // if (context.prize == 'progas')
        // {
        //   pp = 3
        //   this.winner = true;
        // }
        // if (context.prize == 'gift_voucher')
        // {
        //   pp = 4
        //   this.winner = true;
        // }
        if (context.prize == 'unlucky')
        {
          pp = Math.floor(Math.random() * (this.segments.length - 3 + 1) + 3);
          this.winner = false;
        }
        var prizeNumber =pp;// Math.floor(Math.random() * this.segments.length) // or just get from Backend
        var stopAt = 360 / this.segments.length * prizeNumber - 360 / this.segments.length / 2 // center pin
        // var stopAt = 360 / this.segments.length * prizeNumber - Math.floor(Math.random() * 60) //random location
        this.theWheel.animation.stopAngle = stopAt
        this.theWheel.startAnimation()
        this.wheelSpinning = false
      }
    },
    resetWheel () {
      this.theWheel = new Winwheel.Winwheel({
        ...this.WinWheelOptions,
        numSegments: this.segments.length,
        segments: this.segments
      })

      if (this.wheelSpinning) {
        this.theWheel.stopAnimation(false) // Stop the animation, false as param so does not call callback function.
      }

      this.theWheel.rotationAngle = 0 // Re-set the wheel angle to 0 degrees.
      this.theWheel.draw() // Call draw to render changes to the wheel.
      this.wheelSpinning = false // Reset to false to power buttons and spin can be clicked again.
    },
    initSpin () {
      this.loadingPrize = true
      this.resetWheel()
      this.loadingPrize = false
    },
    onFinishSpin (indicatedSegment) {
      this.prizeName = indicatedSegment.text
      this.showPrize()
    },
    advance() {
      let vm = this;
      console.log('here2: '+this.$store.state.questions.length);
      // Proceed if less than number of rounds
      if (this.$store.state.round <= (this.$store.state.questions.length-1)) {
        vm.$store.commit('pauseGame');
        //this.playerClickedCard = false;
        vm.$store.commit('playerClickedCard', false);
        //this.resultsView = false;
        vm.$store.commit('setResults', false);
        //this.timerCount = 30;
        vm.$store.commit('setIsOnBreak');
      }else
      {
        setTimeout(function(){
          vm.$store.commit('isGameOver');
        }, 1500);
      }
    },
  },
  computed: {
    round() {
      console.log('round');
      console.log(this.$store.getters.round);
      return this.$store.getters.round;
    }
  },
  updated () {},
  mounted () {
    this.image_url = require("@/assets/prize.jpg");
    this.getPrizes();
    this.initSpin()
    // this.resetWheel()
  },
  created () {}
}

</script>

<style scoped>
.vue-winwheel {
  text-align: center;
  background-image: url('/spinner-marker.svg');
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
}
.vue-winwheel h1 {
  color: #93278FFF;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 18px;
  line-height: 60px;
  letter-spacing: 4px;
  margin: 0;
}
.vue-winwheel h2 {
  margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content {
  width: calc(100vw - 30px);
  padding-top: 52px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content h2 {
  text-transform: uppercase;
  color: #fbb03b;
  margin-bottom: 16px;
  margin-top: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 18px;
  letter-spacing: 1.1px;
  margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #fbb03b;
  text-align: center;
  line-height: 25px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p strong {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss {
  top: 12px;
  right: 12px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss i.icon_close {
  font-size: 30px;
  color: #fbb03b;
}
.vue-winwheel canvas#canvas {
  position: relative;
}
.vue-winwheel .canvas-wrapper {
  position: relative;
}
.vue-winwheel .canvas-wrapper:after {
  content: '';
  display: block;
  width: 42px;
  background: #0f0f0f;
  height: 42px;
  position: absolute;
  left: calc(50% - 25px);
  margin: auto;
  border-radius: 100%;
  top: calc(50% - 29px);
  border: 5px solid white;
  box-sizing: content-box;
}
.vue-winwheel .canvas-wrapper:before {
  content: '';
  display: block;
  width: 310px;
  background: #0f0f0f;
  height: 310px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 100%;
  top: 0;
}
.vue-winwheel .wheel-wrapper {
  position: relative;
}
.vue-winwheel .wheel-wrapper:before {
  content: '';
  width: 62px;
  height: 47px;
  position: absolute;
  top: -10px;
  left: calc(50% - 31px);
  right: 0;
  display: block;
  z-index: 99999;
  background-image: url('./spinner-marker.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.vue-winwheel .wheel-wrapper .button-wrapper {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 231px;
  height: 118px;
}
.vue-winwheel .wheel-wrapper .btn.btn-play {
  padding: 0 58px !important;
  background: #0f0f0f;
  height: 40px;
  line-height: 40px;
  color: white;
  font-weight: bold;
  text-decoration: none;
  border-radius: 2px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  letter-spacing: 2px;
}
</style>
<style lang="sass" scoped>
.modal-backdrop
  position: fixed
  top: 0
  bottom: 0
  left: 0
  right: 0
  background-color: rgba(0, 0, 0, 0.3)
  display: flex
  justify-content: center
  align-items: center

  .modal
    background: #FFFFFF
    box-shadow: 2px 2px 20px 1px
    overflow-x: auto
    display: flex
    border-bottom: 4px solid #008F41
    width: 80%
    text-align: center
    justify-content: center
    min-height: 130px
    flex-direction: column

  .modal-header, .modal-footer
    padding: 15px
    display: flex

  .modal-header
    border-bottom: 1px solid #eeeeee
    color: #4AAE9B
    justify-content: space-between

  .modal-footer
    border-top: 1px solid #eeeeee
    justify-content: flex-end

  .modal-body
    position: relative
    padding: 20px 10px

  .btn-close
    border: none
    font-size: 20px
    padding: 20px
    cursor: pointer
    font-weight: bold
    color: #4AAE9B
    background: transparent

  .btn-green
    color: white
    background: #4AAE9B
    border: 1px solid #4AAE9B
    border-radius: 2px
</style>
